<div class="instruct">
    <div class="int1" style="margin-left: 17px">
        <span class="inst" style="font-size: 12px"><strong> Instructions </strong></span>
        <br />
        <span class="txt">
            1. Select atleast one value out of INTERMILES Number,Airline PNR,Booking Reference No,Ticket
            No,First Name,Last Name,Booking Status.
        </span>
        <br />
        <span class="txt">
            2. If using date range one date range is required.
        </span>
        <br />
        <span class="txt">
            3. Please enter a 9-digit IM Number, or an 11-digit Number with `00` prefixed to the 9-digit IM Number.
        </span>
        <br />
        <span></span>
    </div>
</div>